/**
 * Shared F/E and API enum, DO NOT change values
 */
export enum ViAnalysisEnum {
    SENTIMENT_ANALYSIS = 'BRAND_SENTIMENT',
    REPRESENTATION_ANALYSIS = 'BRAND_REPRESENTATION',
    COMPETITIVE_ANALYSIS = 'COMPETITIVE_BRAND',
    CITATION_AUTHORITY_ANALYSIS = 'CITATION_AUTHORITY',
    CUSTOM = 'CUSTOM'
}
